import React, { useRef } from 'react';
import ChatIcon from './ChatIcon';
import ChatSessions from './ChatSessions';
import ChatMessage from './ChatMessage';
import ChatComposer from './ChatComposer';
import './assistant-chat.css';

export default function AssistantChatLayout({ chats, activeChat, messages, input, setInput, isSending, error, bodyRef, onSubmit, onNew, onSelect, onDelete, onNavigate, shortcuts }) {
  const dialogRef = useRef(null);
  const closeSessions = () => { if (dialogRef.current?.open) dialogRef.current.close(); };
  const visibleMessages = messages.filter((message) => !message.excludeFromContext);
  const sessionsProps = {
    chats, activeId: activeChat?.id, isSending,
    onNew: () => { onNew(); closeSessions(); },
    onSelect: (id) => { onSelect(id); closeSessions(); },
    onDelete,
  };
  return (
    <div className="assistant-chat">
      <aside className="chat-sidebar"><ChatSessions {...sessionsProps} /></aside>
      <dialog className="chat-sessions-dialog" ref={dialogRef} aria-label="Sesiones" onClick={(event) => { if (event.target === event.currentTarget) event.currentTarget.close(); }}>
        <div className="chat-dialog-panel"><button className="chat-dialog-close chat-icon-button" aria-label="Cerrar" onClick={() => dialogRef.current.close()}><ChatIcon name="close" /></button><ChatSessions {...sessionsProps} /></div>
      </dialog>
      <main className="chat-main">
        <header className="chat-header">
          <button className="chat-mobile-menu chat-icon-button" aria-label="Sesiones" onClick={() => dialogRef.current.showModal()}><ChatIcon name="menu" /></button>
          <span className="chat-header-title">Asistente administrativo</span>
          <span className="chat-test-badge">Test</span>
          <button className="chat-header-new chat-icon-button" aria-label="Nuevo chat" title="Nuevo chat" disabled={isSending} onClick={onNew}><ChatIcon name="plus" /></button>
        </header>
        <div className={`chat-scroll ${visibleMessages.length ? '' : 'chat-scroll-empty'}`} ref={bodyRef}>
          {visibleMessages.length ? (
            <div className="chat-thread" role="log" aria-label="Chat">
              {visibleMessages.map((message) => <ChatMessage key={message.id} message={message} onNavigate={onNavigate} />)}
              {isSending && <div className="chat-message chat-message-assistant" role="status" aria-label="Analizando documentos y datos del sistema..."><span className="chat-avatar"><ChatIcon name="drop" /></span><div className="chat-thinking"><i /><i /><i /></div></div>}
            </div>
          ) : (
            <div className="chat-empty">
              <div className="chat-empty-symbol"><ChatIcon name="drop" /></div>
              <h1>Asistente administrativo</h1>
              <div className="chat-empty-shortcuts">{shortcuts.map((shortcut) => <button key={shortcut.route} onClick={() => onNavigate(shortcut.route)}>{shortcut.label}<ChatIcon name="external" /></button>)}</div>
            </div>
          )}
        </div>
        <ChatComposer value={input} onChange={setInput} onSubmit={onSubmit} isSending={isSending} error={error} />
      </main>
    </div>
  );
}
